<div id="loading_data" class="center-page">
  <i class="fal fa-spinner-third spinning"></i>
  <i class="far fa-spinner-third spinning2"></i>
  <i class="fas fa-spinner-third spinning3"></i>
</div>
